import { useEffect, useState } from "react";
import { keyframes } from "@emotion/react";
import { Box, Grid, Link, Text, useColorMode } from "@chakra-ui/react";
import { getCurrentColor } from "../../constants";

const MainPageFreeAmmo = () => {
  const { colorMode } = useColorMode();

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const pulseAnimation = keyframes`
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  `;

  useEffect(() => {
    const contestEndDate = new Date("2025-09-01T00:00:00-06:00");

    const calculateTimeLeft = () => {
      const difference = contestEndDate.getTime() - new Date().getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();

    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Box pt={{ base: 4, md: 2 }}>
      <Box position="relative" maxW="5xl" mx="auto">
        <Box display="flex" alignItems="center" justifyContent="center">
          <Box
            zIndex={10}
            maxW="4xl"
            mx="auto"
            textAlign="center"
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <Box
              mb={{ base: 4, md: 8 }}
              flexDirection="column"
              alignItems="center"
              display="flex"
            >
              <Text
                fontSize={{
                  base: "3xl",
                  sm: "4xl",
                  md: "5xl",
                  lg: "6xl",
                  xl: "7xl",
                }}
                fontWeight="extrabold"
                color={getCurrentColor(colorMode, "blackC.200", "whiteC.100")}
                lineHeight="normal"
              >
                <span>FREE AMMO </span>
                <Text
                  as="span"
                  color="blue.400"
                  animation={`${pulseAnimation} 2s infinite`}
                  filter={"drop-shadow(0 0 12px rgba(59, 130, 246, 0.9))"}
                  lineHeight="normal"
                >
                  FOR LIFE
                </Text>
              </Text>

              <Text
                fontSize={{
                  base: "3xl",
                  sm: "4xl",
                  md: "5xl",
                  lg: "6xl",
                  xl: "7xl",
                }}
                fontWeight="extrabold"
                color={getCurrentColor(colorMode, "blackC.200", "whiteC.100")}
                lineHeight="normal"
              >
                GIVEAWAY
              </Text>
            </Box>

            <Box w="full" textAlign="center" px={2}>
              <Text
                fontSize={{
                  base: "xl",
                  sm: "2xl",
                  md: "3xl",
                  lg: "4xl",
                  xl: "5xl",
                }}
                color={getCurrentColor(colorMode, "grayC.100", "grayC.1600")}
                mb={6}
              >
                One Free Case Per Year For 80 Years
              </Text>

              <Grid
                templateColumns={{
                  base: "repeat(2, 1fr)",
                  md: "repeat(4, 1fr)",
                }}
                gap={{ base: 3, sm: 4, md: 3, lg: 4 }}
              >
                <Box
                  bg={getCurrentColor(colorMode, "blueC.800", "grayC.1700")}
                  backdropFilter="blur-sm"
                  rounded="lg"
                  textAlign="center"
                  px={{ base: 2, sm: 4, md: 6 }}
                  py={{ base: 3, md: 5 }}
                >
                  <Text
                    fontSize={{ base: "lg", sm: "xl", md: "3xl", lg: "4xl" }}
                    fontWeight="bold"
                    color={getCurrentColor(
                      colorMode,
                      "blackC.200",
                      "whiteC.100",
                    )}
                  >
                    80,000
                  </Text>
                  <Text
                    fontSize={{ base: "xs", md: "sm" }}
                    color={getCurrentColor(
                      colorMode,
                      "grayC.100",
                      "grayC.1600",
                    )}
                  >
                    Rounds of Ammo
                  </Text>
                </Box>

                <Box
                  bg={getCurrentColor(colorMode, "blueC.800", "grayC.1700")}
                  backdropFilter="blur-sm"
                  rounded="lg"
                  textAlign="center"
                  px={{ base: 2, sm: 4, md: 6 }}
                  py={{ base: 3, md: 5 }}
                >
                  <Text
                    fontSize={{ base: "lg", sm: "xl", md: "3xl", lg: "4xl" }}
                    fontWeight="bold"
                    color={getCurrentColor(
                      colorMode,
                      "blackC.200",
                      "whiteC.100",
                    )}
                  >
                    1
                  </Text>
                  <Text
                    fontSize={{ base: "xs", md: "sm" }}
                    color={getCurrentColor(
                      colorMode,
                      "grayC.100",
                      "grayC.1600",
                    )}
                  >
                    Winner
                  </Text>
                </Box>

                <Box
                  bg={getCurrentColor(colorMode, "blueC.800", "grayC.1700")}
                  backdropFilter="blur-sm"
                  rounded="lg"
                  textAlign="center"
                  px={{ base: 2, sm: 4, md: 6 }}
                  py={{ base: 3, md: 5 }}
                >
                  <Text
                    fontSize={{ base: "lg", sm: "xl", md: "3xl", lg: "4xl" }}
                    fontWeight="bold"
                    color={getCurrentColor(
                      colorMode,
                      "blackC.200",
                      "whiteC.100",
                    )}
                  >
                    Free
                  </Text>
                  <Text
                    fontSize={{ base: "xs", md: "sm" }}
                    color={getCurrentColor(
                      colorMode,
                      "grayC.100",
                      "grayC.1600",
                    )}
                  >
                    To Enter
                  </Text>
                </Box>

                <Box
                  bg={getCurrentColor(colorMode, "blueC.800", "grayC.1700")}
                  backdropFilter="blur-sm"
                  rounded="lg"
                  textAlign="center"
                  px={{ base: 2, sm: 4, md: 6 }}
                  py={{ base: 3, md: 5 }}
                >
                  <Text
                    fontSize={{ base: "lg", sm: "xl", md: "3xl", lg: "4xl" }}
                    fontWeight="bold"
                    color={getCurrentColor(
                      colorMode,
                      "blackC.200",
                      "whiteC.100",
                    )}
                  >
                    9mm
                  </Text>
                  <Text
                    fontSize={{ base: "xs", md: "sm" }}
                    color={getCurrentColor(
                      colorMode,
                      "grayC.100",
                      "grayC.1600",
                    )}
                  >
                    Brass Case
                  </Text>
                </Box>

                {/* <Box
                  bg={getCurrentColor(colorMode, "blueC.800", "grayC.1700")}
                  backdropFilter="blur-sm"
                  rounded="lg"
                  textAlign="center"
                  px={{ base: 2, sm: 4, md: 6 }}
                  py={{ base: 3, md: 5 }}
                >
                  <Text
                    fontSize={{ base: "md", sm: "lg", md: "2xl", lg: "3xl" }}
                    fontWeight="bold"
                    color={getCurrentColor(
                      colorMode,
                      "blackC.200",
                      "whiteC.100",
                    )}
                  >
                    9mm
                  </Text>
                  
                  <Text
                    fontSize={{ base: "xs", md: "sm" }}
                    color={getCurrentColor(
                      colorMode,
                      "grayC.100",
                      "grayC.1600",
                    )}
                  >
                    Or Partial Cash Value
                  </Text>
                </Box> */}
              </Grid>

              <Box
                display="flex"
                flexDirection={{ base: "column", md: "row" }}
                alignItems="center"
                justifyContent="center"
                gap={{ base: 4, md: 6 }}
                mt={{ base: 6, md: 10 }}
              >
                {/* <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  mb={{ base: 4, md: 0 }}
                >
                  <Text
                    fontSize={{ base: "xs", sm: "sm" }}
                    color={getCurrentColor(
                      colorMode,
                      "grayC.100",
                      "grayC.1600",
                    )}
                    mb={{ base: 1, md: 2 }}
                  >
                    Sponsored by:
                  </Text>
                  <Image
                    src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Aguila_C-2WKrhQDnCsXrrK7vWh0M3uTor7Em3U.png"
                    alt="Aguila Logo"
                    maxWidth={{
                      base: "144px",
                      sm: "192px",
                      md: "228px",
                      lg: "256px",
                    }}
                  />
                </Box> */}

                <Box
                  w="full"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                >
                  <Text
                    fontSize={{ base: "xs", sm: "sm" }}
                    color={getCurrentColor(
                      colorMode,
                      "grayC.100",
                      "grayC.1600",
                    )}
                    mb={{ base: 1, sm: 2 }}
                  >
                    Contest Ends In:
                  </Text>

                  <Grid templateColumns="repeat(4, 1fr)" gap={2} w="full">
                    {["days", "hours", "minutes", "seconds"].map(
                      (unit, index) => (
                        <Box
                          key={index}
                          textAlign="center"
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                        >
                          <Box
                            bg={getCurrentColor(
                              colorMode,
                              "blueC.800",
                              "grayC.1700",
                            )}
                            rounded="lg"
                            w="full"
                            py={{ base: 1, md: 2 }}
                            textAlign="center"
                          >
                            <Text
                              fontSize={{
                                base: "md",
                                sm: "lg",
                                md: "2xl",
                                lg: "3xl",
                              }}
                              fontWeight="bold"
                              color={getCurrentColor(
                                colorMode,
                                "blackC.200",
                                "whiteC.100",
                              )}
                            >
                              {timeLeft[unit].toString().padStart(2, "0")}
                            </Text>
                          </Box>
                          <Text
                            fontSize={{ base: "md", xs: "10px" }}
                            mt={{ base: 0.5, sm: 1 }}
                            color={getCurrentColor(
                              colorMode,
                              "grayC.100",
                              "grayC.1600",
                            )}
                          >
                            {unit.charAt(0).toUpperCase() + unit.slice(1)}
                          </Text>
                        </Box>
                      ),
                    )}
                  </Grid>
                </Box>
              </Box>

              <Box
                display="flex"
                justifyContent="center"
                w="full"
                mt={{ base: "24px", md: 10 }}
              >
                <Link
                  href="/giveaway"
                  _hover={{
                    color: getCurrentColor(
                      colorMode,
                      "blackC.200",
                      "whiteC.100",
                    ),
                    borderColor: "blue.300",
                    boxShadow: "0 0 15px rgba(96,165,250,0.5)",
                    transitionDuration: "300ms",
                  }}
                  boxShadow="0 0 10px rgba(96,165,250,0.3)"
                  borderColor="blue.400"
                  color="blue.400"
                  border="1px solid"
                  w="full"
                  bg="transparent"
                  fontSize={{ base: "md", sm: "lg", md: "xl", lg: "2xl" }}
                  fontWeight="medium"
                  py={{ base: 2, sm: 3, md: 4 }}
                  px={{ base: 4, sm: 6, md: 8 }}
                  rounded="lg"
                  animation={`${pulseAnimation} 2s infinite`}
                  transition="all 300ms ease-in-out"
                  minHeight="min-content"
                >
                  ENTER CONTEST NOW
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MainPageFreeAmmo;
